// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__JWLwF","green":"Layout_green__LxpAV","headerContainer":"Layout_headerContainer__7w5jI","pink":"Layout_pink__bZPfU","blue":"Layout_blue__JHH9z"};